(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name core.factory:SessionService
     *
     * @description
     *
     */
    angular
        .module('core')
        .factory('SessionService', SessionService);

    function SessionService($sessionStorage, $rootScope, ConfigService, $interval) {

        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        var SessionServiceBase = {};
        SessionServiceBase.errorKey = "";
        SessionServiceBase.errorDescription = "";

        SessionServiceBase.init = function () {
            console.log("Session service init() -- start");
            //Performs storing of data
            SessionServiceBase.errorKey = "";
            SessionServiceBase.errorDescription = "";

            // var data = $location.hash(); //all data retreived from oauth2
            var data = window.location.hash;
            //var tempUrl = window.location.href;
            //var data = tempUrl.split("#");
            console.log("Data from Oauth: " + data);

            if (data != "") {
                var dataList = data.split('&');

                console.log("dataList=" + dataList);
                //now we have all parts, and we should add it to session
                console.log("Item 1", dataList[0]);
                console.log("Item 2", dataList[1]);
                console.log("Item 3", dataList[2]);
                console.log("Item 4", dataList[3]);

                var accessTokenData = dataList[0].split('=');
                var tokenTypeData = dataList[1].split('=');
                var expiresInData = dataList[2].split('=');
                var stateData = dataList[3].split('=');


                /*var accessTokenArray = accessTokenData[1].split(".");
                var dataToken = accessTokenArray[1];
                console.log("accessTokenArray", accessTokenArray);
                console.log("dataToken", dataToken);
                var ataLength = dataToken.length;
                var ataModulo = ataLength % 4;
                if (ataModulo == 0) {
                    dataToken = dataToken + "";
                } else if (ataModulo == 1) {
                    dataToken = dataToken + "===";
                } else if (ataModulo == 2) {
                    dataToken = dataToken + "==";
                } else if (ataModulo == 3) {
                    dataToken = dataToken + "=";
                }
                var tokenData = base64.decode(dataToken);
                console.log("Token Data: ", tokenData);
                var jsonObject = JSON.parse(tokenData);
                $rootScope.GTM_DATA_USERID = jsonObject.unique_name;
                console.log("Token userId: ", $rootScope.GTM_DATA_USERID);*/


                $sessionStorage.ct_accessToken = accessTokenData[1];
                $sessionStorage.token_type = tokenTypeData[1];
                $sessionStorage.expires_in = expiresInData[1];
                $sessionStorage.state = stateData[1];

                var host = window.location;
                var pathname = location.pathname.substring(0, location.pathname.lastIndexOf("/"));
                var redirectUrl = host.protocol + '//' + host.host + pathname + '/';

                console.log('new redirecting to: ' + redirectUrl);
                console.log($sessionStorage.ct_accessToken);
                console.log($sessionStorage.token_type);
                console.log($sessionStorage.expires_in);
                console.log($sessionStorage.state);

                // flush storage
                $sessionStorage.$apply();

                // If there was previous
                if ($sessionStorage.lastUrl) {
                    var lastUrl = $sessionStorage.lastUrl;
                    delete $sessionStorage.lastUrl;
                    // window.location.href = lastUrl;
                    this.waitForAccessTokenChangeAndRedirect(accessTokenData[1], lastUrl);
                } else {
                    // window.location.href = redirectUrl;
                    this.waitForAccessTokenChangeAndRedirect(accessTokenData[1], redirectUrl);
                }

                return true;
            } else {
                console.log("Session service -- no data from OAuth");

                SessionServiceBase.errorKey = getParameterByName("error");
                SessionServiceBase.errorDescription = getParameterByName("error_description");

                return false;
            }
        };

        SessionServiceBase.authorize = function () {
            console.log("Session service authorize()");
            console.log(ConfigService.authorizationUrl);
            console.log("Session service authorizeUrl: " + ConfigService.authorizationUrl);
            window.location.href = ConfigService.authorizationUrl;
        };

        function clearSession() {
            localStorage.clear();
            sessionStorage.clear();
        }

        SessionServiceBase.saveCurrentState = function () {
            if (!$sessionStorage.lastUrl) {
              var countryCode = ($rootScope.APP_GLOBAL_SETTINGS.defaultData) ? $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation : null ;
              $sessionStorage.lastUrl = (!countryCode || countryCode !== 'sl') ? window.location.href : (window.location.href.split('/#!')[0] + '/#!/dashboard');
            }
        };

        SessionServiceBase.saveStorageObject = function (o, t) {
            $sessionStorage.paymentStorageObject = {
                object: o,
                type: t
            };

        };

        SessionServiceBase.removeStorageObject = function () {
            delete $sessionStorage.paymentStorageObject;
        };


        SessionServiceBase.logout = function () {
            clearSession();
            console.log(ConfigService.logoutUrl);
            window.location.href = ConfigService.logoutUrl;
        };

        SessionServiceBase.waitForAccessTokenChangeAndRedirect = function (value, url) {
            if (JSON.parse(sessionStorage.getItem('ngStorage-ct_accessToken')) == value) {
                window.location.href = url;
                return;
            }

            var interval = $interval(function () {
                if (JSON.parse(sessionStorage.getItem('ngStorage-ct_accessToken')) == value) {
                    $interval.cancel(interval);
                    window.location.href = url;
                }
            }, 100);
        };

        return SessionServiceBase;
    }
}());
